module.exports = __webpack_public_path__ + "static/media/connect.b10a716f.jpg";